import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type UserModel from './user.ts';

export type RemoteEventLogLevel = 'DEBUG' | 'INFO' | 'WARNING' | 'ERROR';

type RemoteEventProvider = 'spinwheel' | 'finicity';

export type RemoteEventProviderContext = {
  eventName?: string;
  message?: string;
  [key: string]: unknown;
};

type RemoteEventProviderPayload = {
  context?: RemoteEventProviderContext;
  callback?: string | null;
};

type RemoteEventEventPayload = {
  id: string;
  eventName?: string;
  institution?: { id: string; name: string };
  company?: { id: string; name: string };
  document?: { id: string };
  asset?: { id: string };
  servicer_name?: string;
  pseudo_accounts?: string;
  documentType?: string;
} & Partial<Record<RemoteEventProvider, RemoteEventProviderPayload>>;

export type RemoteEventPayload = {
  logLevel?: RemoteEventLogLevel;
  data: {
    component?: string;
    event: RemoteEventEventPayload;
  };
};

export default class RemoteEventModel extends Model {
  @attr declare eventType: string;
  @attr declare payload: RemoteEventPayload;
  @attr declare at: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('user', { async: false, inverse: null })
  declare user: UserModel;

  [Type] = 'remote-event' as const;
}
